import { useEffect, useState } from 'react';

/**
 * 获取元素填满剩余高度时的高度
 * @param selector 选择器
 */
export function useFillHeight(selector: string): [number, () => void] {
  const [height, setHeight] = useState<number>(0);

  function getHeight(): void {
    const element = document.querySelector(selector);
    const { top = 0 } = element?.getBoundingClientRect() ?? {};
    setHeight(window.innerHeight - top);
  }

  useEffect(() => {
    getHeight();
    window.addEventListener('resize', getHeight);

    return (): void => {
      window.removeEventListener('resize', getHeight);
    };
  }, [selector]);

  return [height, getHeight];
}
